/**
 * One surface's material as its adapters install it: the scalars a source decodes to, with every
 * texture bound, derived once into the two bags (ADR-0039). A caller loads, decodes and binds
 * nothing itself.
 */
import { useMemo } from 'react';
import { standardMaterialBags, } from '../../resources/materials/standardmaterial3d/materialBag';
import { parseStandardMaterial3DScalars } from '../../resources/materials/standardmaterial3d/scalars';
import { useSurfaceTextures } from './surfaceTextures';
import { readyMaterial, useMaterial } from './useMaterial';
/** The material `source` draws on `surface`, whichever file it came from: a glTF surface's UVs run top-down. */
export function useSurfaceMaterial(source, surface) {
    const loaded = useMaterial(source);
    const material = readyMaterial(loaded);
    const scalars = useDecodedScalars(material);
    const textures = useSurfaceTextures(scalars, material, surface);
    // No bags while unresolved, so a late map leaves the placeholder material as it is.
    const bags = useMemo(() => textures && standardMaterialBags(scalars, textures), [scalars, textures]);
    return { scalars, isAbsent: loaded.status === 'absent', bags, material };
}
function useDecodedScalars(material) {
    const resource = material?.resource;
    return useMemo(() => (resource ? parseStandardMaterial3DScalars(resource.data) : null), [resource]);
}
//# sourceMappingURL=useSurfaceMaterial.js.map